import { projectContext } from '@/layouts/MainLayout'
import { Button, Select, Typography } from 'antd'
import { createContext, memo, useContext, useEffect, useMemo, useState } from 'react'
import { Gantt, ViewMode } from 'gantt-task-react'
import styles from './index.module.less'
import 'gantt-task-react/dist/index.css'
import TaskFilter, { initialTaskFilters, TaskFilters } from '../components/TaskFilter'
import { getProjectMembers } from '@/services/member/member'
import { useRequest } from 'ahooks'
import { useFilterTaskTree, useRequestTaskList } from '../hooks'
import { TaskListTable } from './TaskList/Table'
import { TaskListHeader } from './TaskList/Header'

const { Text } = Typography

export const TaskListContext = createContext<any>({})

const ProjectTaskGantt = memo(function () {
  const { projectType, projectId } = useContext(projectContext)
  const [taskFilters, setTaskFilters] = useState<TaskFilters>(initialTaskFilters)
  const [ganttTasks, setGanttTasks] = useState<any[]>([])
  const [taskType, setTaskType] = useState('open')
  const [viewMode, setViewMode] = useState<ViewMode>(ViewMode.Day)
  const { data: members = [] } = useRequest(() => getProjectMembers(projectId))
  const { taskList, taskMeta } = useRequestTaskList(taskType)
  const filterTaskTree = useFilterTaskTree(taskList, taskFilters)

  useEffect(() => {
    const tasks: any[] = []
    const taskTreeToGantt = (taskTree) => {
      taskTree?.forEach((task) => {
        const ganttTask = {
          start: task.startDate ? new Date(task.startDate) : new Date(),
          end: task.endDate ? new Date(task.endDate) : new Date(),
          name: task.name,
          id: task.id,
          type: task.children ? 'project' : 'task',
          progress: (task.completionRate || 0) * 100,
          isDisabled: true,
          styles: {},
          dependencies: task.predecessorTasks?.map((item) => item.id),
          project: task.parentId,
          hideChildren: false,
          path: task.path,
          assignees: task.assignees
        }
        tasks.push(ganttTask)
        if (task.children) {
          taskTreeToGantt(task.children)
        }
      })
    }
    taskTreeToGantt(filterTaskTree)
    setGanttTasks(tasks)
  }, [filterTaskTree])
  const columnWidth = useMemo(() => {
    switch (viewMode) {
      case ViewMode.Week:
        return 250
      case ViewMode.Month:
        return 300
      default:
        return 65
    }
  }, [viewMode])

  const handleExpanderClick = (task) => {
    setGanttTasks(ganttTasks.map((t) => (t.id === task.id ? task : t)))
  }

  return (
    <div className={styles.container}>

      <div className={styles.filter}>
        <div>
          <Button type='text' onClick={() => setTaskType('open')}>
            <Text strong>{taskMeta.openCount} task</Text>
          </Button>
        </div>

        <div>
          <TaskFilter
            members={members}
            value={taskFilters}
            onChange={(filters) => {
              setTaskFilters(filters)
            }}
          />

          <span className={'ml-1'}>
            <Select style={{ width: '120px' }} value={viewMode} onChange={(value) => setViewMode(value)}>
              {['Hour', 'Day', 'Week', 'Month'].map((item) => (
                <Select.Option key={item} value={item}>
                  {ViewMode[item]}
                </Select.Option>
              ))}
            </Select>
          </span>
        </div>
      </div>

      {ganttTasks?.length > 0 && (
        <Gantt
          tasks={ganttTasks as any}
          viewMode={viewMode}
          columnWidth={columnWidth}
          onExpanderClick={handleExpanderClick}
          TaskListTable={TaskListTable}
          TaskListHeader={TaskListHeader}
        />
      )}
    </div>
  )
})

export default ProjectTaskGantt
